import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { HttpRequestMethod } from './request-methods';
import { RequestOptions } from './request-options';

@Injectable({
  providedIn: 'root'
})
export class HttpApiService {

  constructor(
    private http: HttpClient
  ) { }
  // Consume Api de NodeJs
  apiNode<T>(method: HttpRequestMethod, endPoint: string, params: object = {}, options: RequestOptions = {}): Observable<T> {
    const url = `${environment.urlApi}${endPoint}`;

    return this.send(method, url, params, options);
  }
  // Consumo el Reporteador de FireBaseFunction
  apiReportFunction<T>(method: HttpRequestMethod, endPoint: string, params: object = {}, options: RequestOptions = {}): Observable<T> {
    const url = `${environment.urlReportFunction}${endPoint}`;
    return this.send(method, url, params, options);
  }

  apiNestJs<T>(method: HttpRequestMethod, endPoint: string, params: object = {}, options: RequestOptions = {}): Observable<T> {
    const url = `${environment.urlApiTercerizacionNest}${endPoint}`;

    return this.send(method, url, params, options);
  }
  
  private send<T>(method: HttpRequestMethod, endPoint: string, params: object = {}, options: RequestOptions = {}): Observable<T> {
    const res = this.http.request<T>(method, endPoint, this.requestOptions(method, params, options)).pipe(share());
    return res;
  }

  private requestOptions(method: HttpRequestMethod, params: any, options: RequestOptions): RequestOptions {
    if (method === HttpRequestMethod.POST || method === HttpRequestMethod.PUT) {
      options.body = params;
    } else {
      options.params = params;
    }

    return options;
  }
}
